export const stripThirdLevelNumbering = (title: string): string =>
  title.replace(/^\d+\.\d+\.\d+\.?\s*/, "");

export const extractLeadingNumber = (
  title: string
): { number: string | null; rest: string } => {
  const match = title.match(/^(\d+)\s+(.*)$/);
  if (!match) return { number: null, rest: title };
  return { number: match[1], rest: match[2] };
};
